<kendo-treelist
  kendoTreeListExpandable
  [data]="rootData"
  idField="{{ IdName }}"
  [resizable]="true"
  [loading]="isRefreshing"
  [fetchChildren]="fetchChildren"
  [hasChildren]="hasChildren"
  (add)="addHandler($event)"
  (edit)="editHandler($event)"
  (remove)="removeHandler($event)"
  (save)="saveHandler($event)"
  (cancel)="cancelHandler($event)"
  [style.height.%]="100">
  <ng-template kendoTreeListToolbarTemplate>
    <ssg-button icon="icon-add-o" buttontype="button" (click)="addHandler($event)" class="btnstyle" tooltip="ایجاد رکورد جدید"></ssg-button>
    <ssg-button
      icon="icon-refresh-o"
      buttontype="button"
      (click)="refreshData()"
      [disabled]="isRefreshing"
      class="btnstyle"
      tooltip="بازخوانی اطلاعات">
    </ssg-button>
    <ng-container *ngIf="validactions && validactions.length > 0">
      <ssg-button
        *ngFor="let action of validactions"
        (click)="onToolbarItemClick(action)"
        class="btnstyle"
        data-tooltip="top"
        tooltip="{{ action.displayName }}"
        icon="{{ action.iconName }}"></ssg-button>
    </ng-container>
  </ng-template>

  <kendo-treelist-command-column>
    <ng-template kendoTreeListCellTemplate let-isNew="isNew" let-cellContext="cellContext" let-dataItem="dataItem">
      <!-- "Add Child" command directive, will not be visible in edit mode -->
      <button [kendoTreeListAddCommand]="cellContext" icon="filter-add-expression" title="ایجاد زیرشاخه"></button>

      <!-- "Edit" command directive, will not be visible in edit mode -->
      <button [kendoTreeListEditCommand]="cellContext" icon="edit" title="ویرایش" [primary]="true"></button>

      <!-- "Remove" command directive, will not be visible in edit mode -->
      <button *ngIf="!gethasChildren(dataItem)" [kendoTreeListRemoveCommand]="cellContext" icon="delete" title="حذف"></button>

      <!-- "Save" command directive, will be visible only in edit mode -->
      <button [kendoTreeListSaveCommand]="cellContext" [disabled]="formGroup?.invalid" icon="save" title="{{ isNew ? 'جدید' : 'تغییر' }}"></button>

      <!-- "Cancel" command directive, will be visible only in edit mode -->
      <button [kendoTreeListCancelCommand]="cellContext" icon="cancel" title="{{ isNew ? 'لغو تغییرات' : 'انصراف' }}"></button>
    </ng-template>
  </kendo-treelist-command-column>

  <kendo-treelist-column
    *ngFor="let column of columns"
    field="{{ column.name }}"
    title="{{ column.label }}"
    format="{{ column.format }}"
    [expandable]="column.name == expandableField"
    [width]="column.columnWidth * 5"
    [hidden]="!column.listVisible"
    filter="{{ column.textType == 'checkbox' ? 'boolean' : column.textType == 'number' ? 'numeric' : column.textType == 'date' ? 'date' : 'text' }}">
    <ng-template *ngIf="column.textType == 'checkbox'" kendoTreelistCellTemplate let-dataItem>
      <input type="checkbox" class="k-checkbox" [checked]="dataItem[column.name]" disabled />
    </ng-template>
    <ng-template kendoTreelistGroupHeaderTemplate let-value="value">
      {{ value }}
    </ng-template>
  </kendo-treelist-column>
</kendo-treelist>
